import React, {useState, useEffect, useContext} from "react";
import "./index.css";
import {icons} from "./menuJson";
import RButton from "../components/RButton";
import {message, Slider, Checkbox} from "antd";
import RSwitch from "../components/RSwitch";
import RColorPicker from "../components/RColorPicker";
import {ThemeContext} from "../../App1";
import defaultImage from "../../assets/images/defaultMat.jpg";
import axios from "axios";
import {useSelector, useDispatch} from "react-redux";
import {
  setEditVisible,
  setEditType,
  setSceneModelInfo,
  setSceneModelSetting,
  setLocked,
  setMaterialInfo,
  setMaterialName,
  setMaterialList,
  setModelInfo,
  setModelSetting,
  setModelArrange,
  setModelType,
  setModelAccuracy,
  setModelName,
  setModelList,
} from "../../store/module/app";
import { treeOptions, grassOptions, buildingOptions, furnitureOptions, stoneOptions } from "./modelLabels";

const base = window.base;

const lineOptions = [
  {label: "直线", value: "line"},
  {label: "曲线", value: "curve"},
];
const modelAccuracyOptions = [
  {label: "高", value: "high"},
  {label: "中", value: "middle"},
  {label: "低", value: "low"},
];

function BottomMenu(props) {
  let {webJson, editor} = useContext(ThemeContext);

  const {
    editVisible,
    editType,
    sceneModelInfo,
    sceneModelSetting,
    locked,
    materialInfo,
    materialName,
    materialList,
    modelInfo,
    modelSetting,
    modelArrange,
    modelType,
    modelAccuracy,
    modelName,
    modelList,
  } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  // const editVisible = app.editVisible
  // const editType = app.editType
  // const sceneModelInfo = app.sceneModelInfo
  // const materialInfo = app.materialInfo
  // const modelInfo = app.modelInfo

  // 材质库
  // const [materialList, setMaterialList] = useState([])
  // const [materialName, setMaterialName] = useState('')
  // // 模型库
  // const [modelList, setModelList] = useState([])

  // 模型场景 设置
  // const [sceneModelSetting, setSceneModelSetting] = useState({
  //   row: 1, column: 1, gap: 1
  // })
  // const [locked, setLocked] = useState(false)

  // const [modelSetting, setModelSetting] = useState({
  //   type: 'matrix',//matrix curve 矩阵 曲线
  //   gap: 1, row: 1, column: 1, lineType: 'curve',//line curve 直线 曲线
  //   random: false
  // })

  const [topCatalog, setTopCatalog] = useState([]); //一级目录
  const [currentTopCatalog, setCurrentTopCatalog] = useState(null); //选中的一级目录
  const [currentCatalogList, setCurrentCatalogList] = useState([]); //展开目录的列表
  // const [modelList, setModelList] = useState([])
  const [currentCatalogName,setCurrentCatalogName]=useState(null);
  const [modelCatalog, setModelCatalog] = useState([]); //目录列表
  // const [modelArrange, setModelArrange] = useState('matrix')//matrix curve
  const [expand, setExpand] = useState(false);
  // const [modelType, setModelType] = useState({label: '曲线', value: 'curve'})
  // const [modelName, setModelName] = useState('')
  // 当前选中材质
  const [currentMaterial, setCurrentMaterial] = useState(null);
  // 当前选中模型
  const [currentModel, setCurrentModel] = useState(null);
  const [fullModelList, setFullModelList] = useState([]);
  // 用于标签筛选
  const [selectedTreeType,setSelectedTreeType]=useState('');
  const [selectedTreeSize, setSelectedTreeSize] = useState('');
  const [selectedTreeColor,setSelectedTreeColor]=useState('');
  const [selectedGrassShape, setSelectedGrassShape] = useState('');
  const [selectedGrassColor, setSelectedGrassColor] = useState('');
  const [selectedBuildingType, setSelectedBuildingType] = useState('');
  const [selectedBuildingShape, setSelectedBuildingShape] = useState('');
  const [selectedFurnitureType, setSelectedFurnitureType] = useState('');
  const [selectedFurnitureShape, setSelectedFurnitureShape] = useState('');
  const [selectedStoneType, setSelectedStoneType] = useState('');
  const [selectedStoneSize, setSelectedStoneSize] = useState('');

  // 分页相关状态
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [total, setTotal] = useState(100);

  const [selectExpanded, setSelectExpanded] = useState(false);
  // const [modelAccuracy, setModelAccuracy] = useState({value: 'middle', label: '中'})

  const [messageApi, contextHolder] = message.useMessage();

  // 取色器蒙板
  const [showColorPickerOverlay, setShowColorPickerOverlay] = useState(false);

  // 地形笔刷状态
  const [terrainDirection, setTerrainDirection] = useState(1); // 1为抬升，-1为下降

  //Effect Hook 可以让你在函数组件中执行副作用操作，给useEffect钩子传递第二参数[state]侦听数据变化执行钩子函数，在useEffect内能获取到更新完的数据
  //   useEffect(() => {
  //     console.log('---useEffect--', currentCatalogList)
  //   }, [currentCatalogList])
  //   useEffect(() => {
  //     console.log('==useEffect==', editVisible)
  //   }, [editVisible])
  //   useEffect(() => {
  //     console.log('==useEffect==', editType)
  //   }, [editType])

  /**
   * 拼接服务器地址
   * */
  function joinServer(url) {
    return `${base}/${url}`;
  }

  /**
   * 点击左侧菜单
   * */
  const handleClickItem = async (item) => {
    dispatch(setEditType(item.id));

    // eslint-disable-next-line default-case
    switch (item.id) {
      case "scene":
        editor.setClickMode(2);
        break;
      case "mountain":
        editor.setClickMode(3);
        break;
      case "material":
        await getMaterialList();
        editor.setClickMode(5);
        break;
      case "model":
        getTopCatalogs();
        editor.setClickMode(6);
        break;
      case "road":
        editor.setClickMode(4);
        break;
    }

    editor.setEditPanelType(item.id);
  };

  const handleCloseContent = () => {
    dispatch(setEditVisible(false));
    dispatch(setEditType(""));
    editor.setClickMode(0);
  };

  /*------------------------场景模型---------------------------*/
  /*是否锁住*/
  const handleToggleLock = () => {
    //const flag = !locked;
    const flag=false;
    dispatch(setLocked(flag));

    let sceneModelInfoCopy = {
      ...sceneModelInfo,
      position: {...sceneModelInfo.position},
      rotation: {...sceneModelInfo.rotation},
      scale: {...sceneModelInfo.scale},
    };
    let x = Number(sceneModelInfoCopy.scale.x);
    let y = Number(sceneModelInfoCopy.scale.y);
    let z = Number(sceneModelInfoCopy.scale.z);

    let ave = ((x + y + z) / 3).toFixed(2);

    sceneModelInfoCopy.scale.x = ave;
    sceneModelInfoCopy.scale.y = ave;
    sceneModelInfoCopy.scale.z = ave;

    const lastData = {...sceneModelInfoCopy};
    dispatch(setSceneModelInfo(lastData));
    editor.setModelScale({x: ave, y: ave, z: ave});
  };
  /**
   * 重置场景模型 位置-position 旋转-rotation 缩放-scale
   * */
  const handleResetModelInput = (type) => {
    if (!sceneModelInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    let sceneModelInfoCopy = Object.assign({}, sceneModelInfo);

    if (type === "position" || type === "rotation") {
      sceneModelInfoCopy[type] = {x: 0, y: 0, z: 0};
      const lastData = Object.assign({}, sceneModelInfoCopy);
      setSceneModelInfo(lastData);

      if (type === "position") {
        editor.setModelPosition({x: 0, y: 0, z: 0});
      } else if (type === "rotation") {
        editor.setModelRotation({x: 0, y: 0, z: 0});
      }
    } else if (type === "scale") {
      sceneModelInfoCopy.scale = {x: 1, y: 1, z: 1};
      editor.setModelScale({x: 1, y: 1, z: 1});
    }

    const lastData = Object.assign({}, sceneModelInfoCopy);
    dispatch(setSceneModelInfo(lastData));
  };

  /**
   * 修改场景模型 位置-position 旋转-rotation 缩放-scale
   * */
  const handleChangeModelInput = (e, type, param) => {
    if (!sceneModelInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    // 使用解构赋值来创建副本 - 无效
    // 使用深拷贝创建副本 - 无效
    // 手动创建副本
    let sceneModelInfoCopy = {
      ...sceneModelInfo,
      position: {...sceneModelInfo.position},
      rotation: {...sceneModelInfo.rotation},
      scale: {...sceneModelInfo.scale},
    };

    let inputValue = e.target.value;
    // 使用正则表达式过滤输入
    // 使用正则表达式限制输入格式（允许整数或最多两位小数）
    const filteredValue = inputValue
      .replace(/[^0-9.]/g, "") // 移除非数字和点
      .replace(/^\./g, "") // 不能以点开头
      .replace(/\.+/g, ".") // 只能有一个点
      .replace(/(\..*)\./g, "$1") // 防止多个小数点
      .replace(/(\.\d{4})\d+/, "$1"); // 限制小数点后最多四位

    //if (locked && type === "scale") {
    if(false){
      sceneModelInfoCopy.scale.x = filteredValue;
      sceneModelInfoCopy.scale.y = filteredValue;
      sceneModelInfoCopy.scale.z = filteredValue;
    } else {
      sceneModelInfoCopy[type][param] = filteredValue;
    }

    const lastData = {...sceneModelInfoCopy};
    dispatch(setSceneModelInfo(lastData));
  };

  const handleKeyDownModelInput = (e) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  const handleBlurModelInput = (e, type, param) => {
    if (!sceneModelInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    let inputValue = e.target.value;
    if (inputValue.includes(".")) {
      const [int, dec] = inputValue.split(".");
      inputValue = `${int}.${dec.padEnd(2, "0")}`;
    } else if (inputValue !== "") {
      inputValue += ".00";
    } else if (inputValue === "") {
      inputValue = "0.00";
    }

    let sceneModelInfoCopy = {
      ...sceneModelInfo,
      position: {...sceneModelInfo.position},
      rotation: {...sceneModelInfo.rotation},
      scale: {...sceneModelInfo.scale},
    };
    sceneModelInfoCopy[type][param] = inputValue;
    const lastData = {...sceneModelInfoCopy};
    dispatch(setSceneModelInfo(lastData));

    if (type === "position") {
      const position = sceneModelInfoCopy.position;
      editor.setModelPosition(position);
    } else if (type === "scale") {
      const scale = sceneModelInfoCopy.scale;
      editor.setModelScale(scale);
    } else if (type === "rotation") {
      const rotation = sceneModelInfoCopy.rotation;
      editor.setModelRotation(rotation);
    }
  };

  /**
   * 擦除
   * */
  const handleDeleteSceneModel = () => {
    if (!sceneModelInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    editor.deleteCurrentModel();
  };

  const handleChangeSettingInput = (e, param) => {
    // 过滤掉undo触发的回调 e.nativeEvent.inputType == "historyUndo"
    if (!e || !e.nativeEvent) return;
    if (e.nativeEvent.inputType !== "insertText") return;

    if (!sceneModelInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    let sceneModelSettingCopy = {...sceneModelSetting};

    if (param === "gap") {
      let inputValue = e.target.value;
      // 使用正则表达式过滤输入
      // 使用正则表达式限制输入格式（允许整数或最多两位小数）
      const filteredValue = inputValue
        .replace(/[^0-9.]/g, "") // 移除非数字和点
        .replace(/^\./g, "") // 不能以点开头
        .replace(/\.+/g, ".") // 只能有一个点
        .replace(/(\..*)\./g, "$1") // 防止多个小数点
        .replace(/(\.\d{2})\d+/, "$1"); // 限制小数点后最多两位
      sceneModelSettingCopy[param] = filteredValue;
    } else {
      //sceneModelSettingCopy[param] = Number(e.target.value);
      // 新增对行/列输入的过滤，只允许整数输入
      const inputValue = e.target.value.replace(/[^0-9]/g, "");
      sceneModelSettingCopy[param] = inputValue === "" ? 0 : Number(inputValue);
    }

    let lastData = {...sceneModelSettingCopy};
    dispatch(setSceneModelSetting(lastData));

    editor.setCopyArgs(lastData.row, lastData.column, lastData.gap);
  };

  const handleBlurModelSetting = (e) => {
    let inputValue = e.target.value;
    if (inputValue.includes(".")) {
      const [int, dec] = inputValue.split(".");
      inputValue = `${int}.${dec.padEnd(2, "0")}`;
    } else if (inputValue !== "") {
      inputValue += ".00";
    } else if (inputValue === "") {
      inputValue = "0.00";
    }

    let sceneModelSettingCopy = {...sceneModelSetting};
    sceneModelSettingCopy.gap = inputValue;
    let lastData = {...sceneModelSettingCopy};
    dispatch(setSceneModelSetting(lastData));
  };

  /**
   * 复制
   * */
  const handleCopySceneModel = () => {
    if (!sceneModelInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    const row = sceneModelSetting.row;
    const col = sceneModelSetting.column;
    const dis = sceneModelSetting.gap;

    editor.copyObj(row, col, dis);
  };

  /*-------------------------材质库----------------------------*/
  /**
   * 获取材质库
   * */
  async function getMaterialList() {
    await axios
      .get(base + "/material/search?name=" + materialName)
      .then((res) => {
        console.log(res, res.data);
        if (res.status === 200) {
          const data = res.data.data;
          dispatch(setMaterialList(data));
        }
      });
  }

  /**
   * 修改材质库取色器颜色
   * @param color
   * */
  const handleChangeColor = (color) => {
    if (!materialInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    dispatch(setMaterialInfo((prev) => ({...prev, color: color})));
    editor.setColor(color);
  };

  /**
   * 修改滑动条值
   * @param type 纹理缩放-scale 纹理方向-direction
   * @param value 值
   * */
  const handleChangeSliderValue = (type, value) => {
    if (!materialInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    let materialInfoCopy = Object.assign({}, materialInfo);
    materialInfoCopy[type] = value;
    const lastData = Object.assign({}, materialInfoCopy);
    dispatch(setMaterialInfo(lastData));

    if (type === "scale") {
      editor.setTextureScale(value);
    } else if (type === "direction") {
      editor.setTextureRotation(value);
    }
  };

  /**
   * 查询材质列表
   * */
  const handleSearchMaterial = () => {
    getMaterialList();
  };

  const handleKeyDownSearchMaterial = () => {
    if (window.event.keyCode === 13) {
      handleSearchMaterial();
    }
  };

  /**
   * 点击材质
   * */
  const handleClickMaterial = (item) => {
    if (!materialInfo.isSelect) {
      return messageApi.open({type: "warning", content: "请选择模型"});
    }

    const url = joinServer(item.path);
    const name = item.name;
    console.log(url, name);
    editor.replaceMatFromLib(url, name);
  };

  /*-------------------------模型库----------------------------*/
  /**
   * 获取模型库顶级目录
   * */
  async function getTopCatalogs() {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const majorName = userInfo.major
    await axios.get(base + "/catalog/getTopCatalog?majorName=" + majorName).then(async (res) => {
      if (res.status === 200) {
        const data = res.data.data;
        console.log(data)
        setTopCatalog(data);

        if (data.length > 0) {
          setCurrentTopCatalog(data[0]);
          setCurrentCatalogList(() => []);
          await getCatalogOne(data[0], true);
        }
      }
    });
  }

  /**
   * 点击一级目录
   * */
  const handleClickTopCatalog = async (item) => {
    setCurrentTopCatalog(item);
    setCurrentCatalogList(() => []);
    await getCatalogOne(item, true);
  };

  /**
   * 点击不是一级目录的目录
   * */

  /**
   * 点击目录获取其子目录和模型列表
   * @param item 搜索的项
   * @param add true 添加 false 删除
   * */
  async function getCatalogOne(item, add) {
    setCurrentCatalogName(item.name);
    if (add) {
      addCatalogInList(item);
    } else {
      deleteCatalogInList();
    }

    // 重置所有筛选状态
    setSelectedTreeType('');
    setSelectedTreeSize('');
    setSelectedTreeColor('');
    setSelectedGrassShape('');
    setSelectedGrassColor('');
    setSelectedBuildingType('');
    setSelectedBuildingShape('');
    setSelectedFurnitureType('');
    setSelectedFurnitureShape('');
    setSelectedStoneType('');
    setSelectedStoneSize('');

    const token = sessionStorage.getItem('token')
    await axios.get(base + "/catalog/getOne?_id=" + item._id, {headers: {Authorization: `Bearer ${token}`}}).then((res) => {
      // console.log(res, res.data)
      if (res.status === 200) {
        const data = res.data.data;

        const models = data.filter((item) => item.type === "model");
        const catalogs = data.filter((item) => item.type === "catalog");

        // console.log('********', data, models, catalogs, currentCatalogList)
        dispatch(setModelList(models));
        setFullModelList(models);
        setTotal(models.length);
        setCurrentPage(1);
        setModelCatalog(catalogs);
      }
    });
  }

  /**
   * 搜索模型
   * */
  async function getSearchModel() {
    await axios.get(base + "/model/search?name=" + modelName).then((res) => {
      if (res.status === 200) {
        const models = res.data.data;

        dispatch(setModelList(models));
        setCurrentTopCatalog(null);
        setModelCatalog(() => []);
      }
    });
  }

  const handleSearchModel = async () => {
    await getSearchModel();
  };

  const handleKeyDownSearchModel = async () => {
    if (window.event.keyCode === 13) {
      await handleSearchModel();
    }
  };

  /*切换模型精度*/
  const handleSetModelAccuracy = (item) => {
    dispatch(setModelAccuracy(item));
    setSelectExpanded(false);

    editor.setModellibAccuracy(item);
  };

  /*删除目录项*/
  function deleteCatalogInList() {
    let catalogListCopy = [...currentCatalogList];
    catalogListCopy.pop();
    setCurrentCatalogList(catalogListCopy);
  }

  /*添加目录项*/
  function addCatalogInList(item) {
    setCurrentCatalogList((prev) => [...prev, item]);
  }

  /**
   * 根据筛选条件过滤模型列表
   */
  const filterModelsByConditions = (options={}) => {
    // 取模型列表
    let filteredModels=[...fullModelList];

    const treeSize = options.treeSize || selectedTreeSize;
    const treeType = options.treeType || selectedTreeType;
    const treeColor = options.treeColor || selectedTreeColor;
    const grassShape = options.grassShape || selectedGrassShape;
    const grassColor = options.grassColor || selectedGrassColor;
    const buildingType = options.buildingType || selectedBuildingType;
    const buildingShape = options.buildingShape || selectedBuildingShape;
    const furnitureType = options.furnitureType || selectedFurnitureType;
    const furnitureShape = options.furnitureShape || selectedFurnitureShape;
    const stoneType = options.stoneType || selectedStoneType;
    const stoneSize = options.stoneSize || selectedStoneSize;
    
    // 根据当前目录名称和筛选条件添加参数
    switch (currentCatalogName) {
      case '植物':
      case '乔木类':
        if (treeSize!=null && treeSize!="" && treeSize!='all') {
          filteredModels = filteredModels.filter(model => 
            model.treeSize === treeSize
          );
        }
        if (treeType!=null && treeType!="") {
          filteredModels = filteredModels.filter(model => 
            model.treeShape === treeType
          );
        }
        if (treeColor!=null && treeColor!="") {
          filteredModels = filteredModels.filter(model => 
            model.treeColor === treeColor
          );
        }
        console.log(options,filteredModels,treeSize,treeType,treeColor);
        break;
      case '草灌类':
        if (grassShape!=null && grassShape!="") {
          filteredModels = filteredModels.filter(model => 
            model.grassShape === grassShape
          );
        }
        if (grassColor!=null && grassColor!="") {
          filteredModels = filteredModels.filter(model => 
            model.grassColor === grassColor
          );
        }
        break;
      case '景观构筑':
        if (buildingType!=null && buildingType!="") {
          filteredModels = filteredModels.filter(model => 
            model.buildingType === buildingType
          );
        }
        if (buildingShape!=null && buildingShape!="") {
          filteredModels = filteredModels.filter(model => 
            model.buildingShape === buildingShape
          );
        }
        break;
      case '景观家具':  
        if (furnitureType!=null && furnitureType!="") {
          filteredModels = filteredModels.filter(model => 
            model.furnitureType === furnitureType
          );
        }
        if (furnitureShape!=null && furnitureShape!="") {
          filteredModels = filteredModels.filter(model => 
            model.furnitureShape === furnitureShape
          );
        }
        break;
      case '雕塑景石':
        if (stoneType!=null && stoneType!="") {
          filteredModels = filteredModels.filter(model => 
            model.stoneType === stoneType
          );
        }
        if (stoneSize!=null && stoneSize!="") {
          filteredModels = filteredModels.filter(model => 
            model.stoneSize === stoneSize
          );
        }
        break;
    }
    

    // 发送请求获取过滤后的模型列表
    setTotal(filteredModels.length);
    setCurrentPage(1);
    dispatch(setModelList(filteredModels));
  }

  /**
   * 点击返回
   * */
  const handleClickBack = async () => {
    const len = currentCatalogList.length;
    const catalogListCopy = [...currentCatalogList];
    if (len > 1) {
      const lastCatalog = catalogListCopy[len - 2];
      await getCatalogOne(lastCatalog, false);
    }
  };

  const handleChangeModelLibType = (type) => {
    dispatch(setModelArrange(type));
    editor.setModelLibType(type);
  };

  // 修改线条类型
  const handleModelType = (type) => {
    dispatch(setModelType(type));
    let modelSettingCopy = Object.assign({}, modelSetting);
    modelSettingCopy.lineType = type.value;
    const lastData = Object.assign({}, modelSettingCopy);
    dispatch(setModelSetting(lastData));
    setExpand(false);

    const dis = lastData.gap;
    const random = lastData.random;
    editor.setCurveArgs(dis, type, random);
  };

  const handleCertainCurve = () => {
    editor.confirmCurve();
  };

  /**
   * 修改输入框值
   * @param e 控件对象
   * @param param 修改的模型当前参数名
   * */
  const handleChangeModelParamInput = (e, param) => {
    // 过滤掉undo触发的回调 e.nativeEvent.inputType == "historyUndo"
    if (!e || !e.nativeEvent) return;
    if (e.nativeEvent.inputType !== "insertText") return;

    let modelSettingCopy = Object.assign({}, modelSetting);

    if (param === "gap") {
      let inputValue = e.target.value;
      const filteredValue = inputValue
        .replace(/[^0-9.]/g, "") // 移除非数字和点
        .replace(/^\./g, "") // 不能以点开头
        .replace(/\.+/g, ".") // 只能有一个点
        .replace(/(\..*)\./g, "$1") // 防止多个小数点
        .replace(/(\.\d{2})\d+/, "$1"); // 限制小数点后最多两位
      modelSettingCopy.gap = filteredValue;
    } else {
      //modelSettingCopy[param] = Number(e.target.value);
      // 新增对行/列输入的过滤，只允许整数输入
      const inputValue = e.target.value.replace(/[^0-9]/g, "");
      modelSettingCopy[param] = inputValue === "" ? 1 : Number(inputValue);
    }

    const lastData = Object.assign({}, modelSettingCopy);
    dispatch(setModelSetting(lastData));

    setEditorModel(lastData);
  };

  const handleBlurModelParamInput = (e) => {
    let inputValue = e.target.value;
    if (inputValue.includes(".")) {
      const [int, dec] = inputValue.split(".");
      inputValue = `${int}.${dec.padEnd(2, "0")}`;
    } else if (inputValue !== "") {
      inputValue += ".00";
    } else if (inputValue === "") {
      inputValue = "0.00";
    }

    let modelSettingCopy = Object.assign({}, modelSetting);
    modelSettingCopy.gap = inputValue;
    const lastData = Object.assign({}, modelSettingCopy);
    dispatch(setModelSetting(lastData));
    setEditorModel(lastData);
  };

  /**
   * 修改model switch值
   * */
  const handleChangeSwitch = (val) => {
    let modelSettingCopy = Object.assign({}, modelSetting);
    modelSettingCopy.random = val;
    const lastData = Object.assign({}, modelSettingCopy);
    dispatch(setModelSetting(lastData));

    setEditorModel(lastData);
  };

  /**
   * 3d editor 修改模型配置
   * */
  function setEditorModel(lastData) {
    if (modelArrange === "matrix") {
      const row = lastData.row;
      const col = lastData.column;
      const dis = lastData.gap;
      const random = lastData.random;
      editor.setMatrixArgs(row, col, dis, random);
    } else if (modelArrange === "curve") {
      const dis = lastData.gap;
      const type = modelType;
      const random = lastData.random;
      editor.setCurveArgs(dis, type, random);
    }
  }

  /**
   * 点击模型
   * */
  const handleClickModelItem = async (item) => {
    await axios
      .get(`${base}/model/getOne?_id=${item._id}&editorRole=${item.editorRole}`)
      .then(async (res) => {
        console.log(res, res.data, res.data.data);
        if (res.status === 200) {
          const data = res.data.data;

          const url = joinServer(`${data.path}_${modelAccuracy.value}.glb`);
          const modelId = item._id;
          const modelName = item.name;
          const screenshot = item.screenshot;
          console.log(url);
          editor.selectModelibItem(url, screenshot, modelId, modelName);
        }
      })
      .catch((e) => {
        messageApi.open({type: "error", content: e.message});
      });
  };

  /**
   * 搜索
   * */

  return (
    <div className={`bottom-menu-wrapper ${editVisible ? "flex" : "hidden"}`}>
      {/* 取色器蒙板*/}
      {showColorPickerOverlay && (
        <div
          className="color-picker-overlay"
          onClick={() => {
            setShowColorPickerOverlay(false);
          }}
        ></div>
      )}
      {contextHolder}
      <div className="left-menu blur">
        {icons.map((item) => {
          return (
            <div
              className={`left-menu-item ${
                editType === item.id ? "active" : ""
              } ${
                //item.id === "road" ? "disabled" : ""
                ""
              }`}
              key={item.id}
              onClick={() => handleClickItem(item)}
            >
              <span className={`icon ${item.icon}`}></span>
              <span className="text">{item.label}</span>
            </div>
          );
        })}
      </div>

      {/*场景模型*/}
      <div
        className={`right-main blur ${
          editType === "scene" ? "flex" : "hidden"
        } scene`}
      >
        <div className="close" onClick={() => handleCloseContent()}></div>
        <div className="left-content">
          <div className="left-content-main">
            <div className="scene-item">
              <div className="label">名称</div>
              <div className="content">
                <div className="text">{sceneModelInfo.name}</div>
              </div>
            </div>

            {/*<div className="scene-item">*/}
            {/*  <div className="label">面数</div>*/}
            {/*  <div className="content">*/}
            {/*    <div className="text">13.8888</div>*/}
            {/*  </div>*/}
            {/*</div>*/}

            <div className="scene-item">
              <div className="label">位置</div>
              <div className="content">
                <div className="input-group">
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.position.x}
                    onChange={($event) =>
                      handleChangeModelInput($event, "position", "x")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "position", "x")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.position.y}
                    onChange={($event) =>
                      handleChangeModelInput($event, "position", "y")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "position", "y")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.position.z}
                    onChange={($event) =>
                      handleChangeModelInput($event, "position", "z")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "position", "z")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                </div>
                <div
                  className={`reset ${
                    sceneModelInfo.isSelect ? "" : "disabled"
                  }`}
                  onClick={() => handleResetModelInput("position")}
                ></div>
              </div>
            </div>

            <div className="scene-item">
              <div className="label">旋转</div>
              <div className="content">
                <div className="input-group">
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.rotation.x}
                    onChange={($event) =>
                      handleChangeModelInput($event, "rotation", "x")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "rotation", "x")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.rotation.y}
                    onChange={($event) =>
                      handleChangeModelInput($event, "rotation", "y")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "rotation", "y")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.rotation.z}
                    onChange={($event) =>
                      handleChangeModelInput($event, "rotation", "z")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "rotation", "z")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                </div>
                <div
                  className={`reset ${
                    sceneModelInfo.isSelect ? "" : "disabled"
                  }`}
                  onClick={() => handleResetModelInput("rotate")}
                ></div>
              </div>
            </div>

            <div className="scene-item">
              <div className="label">
                缩放
                <span
                  className={`lock ${locked ? "no" : ""}`}
                  onClick={()=>handleToggleLock()}
                />
              </div>
              <div className="content">
                <div className="input-group">
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.scale.x}
                    onChange={($event) =>
                      handleChangeModelInput($event, "scale", "x")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "scale", "x")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.scale.y}
                    onChange={($event) =>
                      handleChangeModelInput($event, "scale", "y")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "scale", "y")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                  <input
                    className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
                    type="text"
                    value={sceneModelInfo.scale.z}
                    onChange={($event) =>
                      handleChangeModelInput($event, "scale", "z")
                    }
                    onBlur={($event) =>
                      handleBlurModelInput($event, "scale", "z")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                </div>
                <div
                  className={`reset ${
                    sceneModelInfo.isSelect ? "" : "disabled"
                  }`}
                  onClick={() => handleResetModelInput("scale")}
                ></div>
              </div>
            </div>
          </div>
          <RButton
            icon="erase"
            text="擦除"
            able={sceneModelInfo.isSelect}
            handleClick={handleDeleteSceneModel}
          />
        </div>
        <div className="right-content">
          <div className="scene-item">
            <div className="label w-50">行数</div>
            <input
              className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
              type="text"
              value={sceneModelSetting.row}
              onChange={($event) => handleChangeSettingInput($event, "row")}
              onKeyDown={handleKeyDownModelInput}
            />
          </div>
          <div className="scene-item">
            <div className="label w-50">列数</div>
            <input
              className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
              type="text"
              value={sceneModelSetting.column}
              onChange={($event) => handleChangeSettingInput($event, "column")}
              onKeyDown={handleKeyDownModelInput}
            />
          </div>
          <div className="scene-item">
            <div className="label w-50">间隔</div>
            <input
              className={`${sceneModelInfo.isSelect ? "" : "disabled"}`}
              type="text"
              value={sceneModelSetting.gap}
              onChange={($event) => handleChangeSettingInput($event, "gap")}
              onBlur={($event) => handleBlurModelSetting($event)}
              onKeyDown={handleKeyDownModelInput}
            />
          </div>

          
          <RButton
            className="copy"
            icon="copy"
            text="复制"
            handleClick={handleCopySceneModel}
          />
        </div>
      </div>

      {/*地形*/}
      <div className={`right-main blur ${editType === 'mountain' ? 'flex' : 'hidden'} terrain`}>
        <div className="close" onClick={() => handleCloseContent()}></div>
        <div className="left-content">
          <div className="left-content-main">
            <div className="terrain-item">
              <div className="label">笔刷工具</div>
              <div className="content">
                <div className="text">地形高度调整</div>
              </div>
            </div>
            
            <div className="terrain-item">
              <div className="label">笔刷半径</div>
              <div className="content">
                <div className="slider-wrapper">
                  <Slider
                    className="r-slider"
                    defaultValue={5}
                    min={1}
                    max={10}
                    step={0.5}
                    onChange={(value) => {
                      if (editor && editor.terrainBrush) {
                        editor.terrainBrush.setRadius(value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="terrain-item">
              <div className="label">笔刷强度</div>
              <div className="content">
                <div className="slider-wrapper">
                  <Slider
                    className="r-slider"
                    defaultValue={1.1}
                    min={1.0}
                    max={3.0}
                    step={0.1}
                    onChange={(value) => {
                      if (editor && editor.terrainBrush) {
                        editor.terrainBrush.setStrength(value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="terrain-item">
              <div className="label">调整方向</div>
              <div className="content">
                <div className="button-group">
                  <button 
                    className={`terrain-btn ${terrainDirection === 1 ? 'active' : ''}`}
                    onClick={() => {
                      setTerrainDirection(1);
                      if (editor && editor.terrainBrush) {
                        editor.terrainBrush.setDirection(1);
                      }
                    }}
                  >
                    抬升
                  </button>
                  <button 
                    className={`terrain-btn ${terrainDirection === -1 ? 'active' : ''}`}
                    onClick={() => {
                      setTerrainDirection(-1);
                      if (editor && editor.terrainBrush) {
                        editor.terrainBrush.setDirection(-1);
                      }
                    }}
                  >
                    下降
                  </button>
                </div>
              </div>
            </div>
            
            <div className="terrain-item">
              <div className="label">操作</div>
              <div className="content">
                <div className="button-group">
                  <button 
                    className="terrain-btn"
                    onClick={() => {
                      if (editor && editor.terrainBrush) {
                        const success = editor.terrainBrush.resetTerrain();
                        if (success) {
                          messageApi.open({type: "success", content: "地形已复原"});
                        } else {
                          messageApi.open({type: "warning", content: "没有可复原的地形"});
                        }
                      }
                    }}
                  >
                    复原地形
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-content">
          <div className="terrain-info">
            <div className="info-text">
              <p>使用说明：</p>
              <p>1. 选择地形模式后，鼠标变为笔刷工具</p>
              <p>2. 点击并拖拽可调整地形高度</p>
              <p>3. 调整笔刷半径和强度来控制效果</p>
              <p>4. 选择抬升或下降方向</p>
            </div>
          </div>
        </div>
      </div>

      {/*材质库*/}
      <div
        className={`right-main blur ${
          editType === "material" ? "flex" : "hidden"
        } material`}
      >
        <div className="close" onClick={() => handleCloseContent()}></div>
        <div className="left-content">
          <div className="back"></div>
          <div className="material-preview-wrapper">
            <div className="preview">
              <img src={materialInfo.image} alt=""/>
            </div>
            <div className="text">{materialInfo.name}</div>
          </div>
          <div className="material-info-wrapper">
            <div className="title">材质编辑</div>
            <div className="material-item">
              <div className="label">材质颜色</div>
              <div className="content">
                <div className="color-picker">
                  <RColorPicker
                    key={materialInfo.isSelect ? "active" : "inactive"} // 通过key强制刷新
                    color={
                      materialInfo.isSelect ? materialInfo.color : "#ffffff"
                    }
                    able={materialInfo.isSelect}
                    id="materialColor"
                    changeColor={(color) => handleChangeColor(color)}
                    onOpen={() => {
                      setShowColorPickerOverlay(true);
                    }}
                    onClose={() => {
                      setShowColorPickerOverlay(false);
                    }}
                  ></RColorPicker>
                </div>
              </div>
            </div>

            <div className="material-item">
              <div className="label">纹理缩放</div>
              <div className="content">
                <div className="slider-wrapper">
                  <Slider
                    className="r-slider"
                    disabled={!materialInfo.isSelect}
                    value={materialInfo.scale}
                    min={1}
                    max={10}
                    step={0.1}
                    onChange={(value) =>
                      handleChangeSliderValue("scale", value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="material-item">
              <div className="label">纹理方向</div>
              <div className="content">
                <div className="slider-wrapper">
                  <Slider
                    className="r-slider"
                    disabled={!materialInfo.isSelect}
                    value={materialInfo.direction}
                    min={0}
                    max={360}
                    step={1}
                    onChange={(value) =>
                      handleChangeSliderValue("direction", value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-content">
          <div className="right-content-header">
            <div className="material-search">
              <div className="prefix" onClick={handleSearchMaterial}></div>
              <input
                type="text"
                className="material-search-input"
                placeholder="搜索"
                value={materialName}
                onChange={($event) =>
                  dispatch(setMaterialName($event.target.value))
                }
                onKeyDown={handleKeyDownSearchMaterial}
              />
            </div>
          </div>
          <div className="right-content-main">
            {materialList &&
              materialList.map((item) => {
                return (
                  <div
                    className="material-info-item"
                    key={item._id}
                    onClick={() => handleClickMaterial(item)}
                  >
                    <div className="material-image">
                      <img src={joinServer(item.image)} alt=""/>
                    </div>
                    <div className="text">{item.name}</div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {/*模型库*/}
      <div
        className={`right-main blur ${
          editType === "model" ? "flex" : "hidden"
        } model`}
      >
        <div className="close" onClick={() => handleCloseContent()}></div>
        <div className="left-content">
          <div className="back" onClick={() => handleClickBack()}></div>
          <div className="model-preview-wrapper">
            <div className="preview">
              <img src={modelInfo.image} alt=""/>
            </div>
            <div className="text">{modelInfo.name}</div>
          </div>
          <div className="model-info-wrapper">
            <div className="title">模型编辑</div>
            {/*<div className="model-item">*/}
            {/*  <div className="label">工具</div>*/}
            {/*  <div className="content">*/}
            {/*    <div className="pencil"></div>*/}
            {/*  </div>*/}
            {/*</div>*/}

            <div
              className={`model-accuracy select-wrapper ${
                selectExpanded ? "expanded" : ""
              }`}
            >
              <div
                className="select-menu"
                onClick={() => setSelectExpanded(!selectExpanded)}
              >
                {modelAccuracy.label}
              </div>
              <div className="select-options blur">
                {modelAccuracyOptions.map((item) => {
                  return (
                    <div
                      className="option"
                      key={item.value}
                      onClick={() => handleSetModelAccuracy(item)}
                    >
                      {item.label}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="model-item">
              <div className="label">间距</div>
              <div className="content">
                <input
                  type="text"
                  value={modelSetting.gap}
                  onChange={($event) =>
                    handleChangeModelParamInput($event, "gap")
                  }
                  onBlur={($event) => handleBlurModelParamInput($event)}
                  onKeyDown={handleKeyDownModelInput}
                />
              </div>
            </div>
            {modelArrange === "curve" ? (
              <div className="model-item">
                <div className="label">类型</div>
                <div className="content">
                  <div className={`select-wrapper ${expand ? "expanded" : ""}`}>
                    <div
                      className="select-menu"
                      onClick={() => setExpand(!expand)}
                    >
                      {modelType.label}
                    </div>
                    <div className="select-options blur">
                      {lineOptions.map((item) => {
                        return (
                          <div
                            className="option"
                            key={item.value}
                            onClick={() => handleModelType(item)}
                          >
                            {item.label}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {modelArrange === "matrix" ? (
              <div className="model-item">
                <div className="label">行</div>
                <div className="content">
                  <input
                    type="text"
                    value={modelSetting.row}
                    onChange={($event) =>
                      handleChangeModelParamInput($event, "row")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                </div>
              </div>
            ) : null}
            {modelArrange === "matrix" ? (
              <div className="model-item">
                <div className="label">列</div>
                <div className="content">
                  <input
                    type="text"
                    value={modelSetting.column}
                    onChange={($event) =>
                      handleChangeModelParamInput($event, "column")
                    }
                    onKeyDown={handleKeyDownModelInput}
                  />
                </div>
              </div>
            ) : null}

            <div className="model-item">
              <div className="label">随机</div>
              <div className="content">
                <RSwitch
                  size="small"
                  checked={modelSetting.random}
                  changeValue={(val) => handleChangeSwitch(val)}
                ></RSwitch>
              </div>
            </div>

            {modelArrange === "curve" ? (
              <RButton
                icon="certain"
                text="确定"
                handleClick={handleCertainCurve}
              ></RButton>
            ) : null}
          </div>

          <div className="show-type">
            <div
              className={`matrix ${modelArrange === "matrix" ? "active" : ""}`}
              onClick={() => handleChangeModelLibType("matrix")}
            ></div>
            <div
              className={`curve ${modelArrange === "curve" ? "active" : ""}`}
              onClick={() => handleChangeModelLibType("curve")}
            ></div>
          </div>

          {/*<RButton icon="certain" text="保存" propsClassName="save"/>*/}
        </div>
        
        <div className="right-content">
          <div className="right-content-header">
            <div className="type">
              {modelCatalog.map((item) => {
                return (
                  <div
                    className={`catalog`}
                    key={item._id}
                    onClick={() => getCatalogOne(item, true)}
                  >
                    {item.name}
                  </div>
                );
              })}
            </div>
            <div className="search">
              <div className="model-search-wrapper">
                <div className="prefix" onClick={handleSearchModel}/>
                <input
                  type="text"
                  className="model-search"
                  value={modelName}
                  placeholder="搜索"
                  onChange={($event) =>
                    dispatch(setModelName($event.target.value))
                  }
                  onKeyDown={handleKeyDownSearchModel}
                />
              </div>
            </div>
          </div>
          <div className="right-content-main">
            <div className="model-layout">
              <div className="model-display-column">
                <div className="model-main">
                  {modelList && modelList.length > 0 ?(
                    modelList.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((item) => {
                      return (
                        <div
                          className="model-info-item"
                          key={item._id}
                          onClick={() => handleClickModelItem(item)}
                        >
                          <div className="model-image">
                            <img src={joinServer(item.screenshot)} alt=""/>
                            <div className="library"> {item.role === 'teacher' ? '标' : '学'}</div>
                          </div>
                          <div className="text">{item.name}</div>
                        </div>
                      );
                    })
                  ):(console.log("暂无数据"))}    
                </div>
                
                {/* 分页组件 - 移至与model-main同级 */}
                {total > 0 && (
                  <div className="pagination-container">
                    <div className="pagination-info">
                      共 {total} 项，第 {currentPage} 页，共 {Math.ceil(total / pageSize)} 页
                    </div>
                    <div className="pagination-controls">
                      {/* 页码下拉框 */}
                      <div className="page-select-wrapper">
                        <label>跳至：</label>
                        <select 
                          className="page-number-select"
                          value={currentPage}
                          onChange={(e) => setCurrentPage(Number(e.target.value))}
                        >
                          {Array.from({ length: Math.max(1, Math.ceil(total / pageSize)) }, (_, index) => (
                            <option key={index + 1} value={index + 1}>
                              第 {index + 1} 页
                            </option>
                          ))}
                        </select>
                      </div>
                      {}
                    </div>
                  </div>
                )}
              </div>
            </div>

            

            <div className="model-catalog-level1">
              <div className="catalog-wrapper">
                {/*topCatalog &&
                  topCatalog.map((item) => {
                    return (
                      <div
                        className={`catalog-item ${
                          currentTopCatalog &&
                          currentTopCatalog._id === item._id
                            ? "active"
                            : ""
                        }`}
                        key={item._id}
                        onClick={() => handleClickTopCatalog(item)}
                      >
                        {item.name}
                      </div>
                    );
                  })*/
                  
                    /*模型库筛选以及分页*/
                    (()=>{
                      if(currentCatalogName==='植物'){
                        return (
                          <>
                            <div className="catalog-filter-item">
                              <label>尺寸：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedTreeSize}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择类型:', e.target.value);
                                  setSelectedTreeSize(e.target.value);
                                  filterModelsByConditions({treeSize: e.target.value});
                                }}
                              >
                                {
                                  treeOptions.size.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>
                            </div>
                            <div className="catalog-filter-item">
                              <label>形态：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedTreeType}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedTreeType(e.target.value);
                                  filterModelsByConditions({treeType: e.target.value});
                                }}
                              >
                                {
                                  treeOptions.shape.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>     
                            </div>

                            <div className="catalog-filter-item">
                              <label>颜色：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedTreeColor}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  setSelectedTreeColor(e.target.value);
                                  console.log('选择高度:', e.target.value);
                                  filterModelsByConditions({treeColor: e.target.value});
                                }}
                              >
                                {
                                  treeOptions.color.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>
                            </div>
                          </>
                        );
                      }
                      else if(currentCatalogName==='乔木类'){
                        return (
                          <>
                            <div className="catalog-filter-item">
                              <label>尺寸：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedTreeSize}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择类型:', e.target.value);
                                  setSelectedTreeSize(e.target.value);
                                  filterModelsByConditions({treeSize: e.target.value});
                                }}
                              >
                                {
                                  treeOptions.size.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>
                            </div>
                            <div className="catalog-filter-item">
                              <label>形态：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedTreeType}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedTreeType(e.target.value);
                                  filterModelsByConditions({treeType: e.target.value});
                                }}
                              >
                                {
                                  treeOptions.shape.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>     
                            </div>

                            <div className="catalog-filter-item">
                              <label>颜色：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedTreeColor}
                                onChange={(e) => {
                                  setSelectedTreeColor(e.target.value);
                                  filterModelsByConditions({treeColor: e.target.value});
                                }}
                              >
                                {
                                  treeOptions.color.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>     
                            </div>
                          </>
                        );
                      }
                      else if(currentCatalogName==='草灌类'){
                        return (
                          <>
                            <div className="catalog-filter-item">
                              <label>形态：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedGrassShape}
                                onChange={(e) => {
                                  setSelectedGrassShape(e.target.value);
                                  filterModelsByConditions({grassShape: e.target.value});
                                }}
                              >
                                {
                                  grassOptions.shape.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>     
                            </div>

                            <div className="catalog-filter-item">
                              <label>颜色：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedGrassColor}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedGrassColor(e.target.value);
                                  filterModelsByConditions({grassColor: e.target.value});
                                }}
                              >
                                {
                                  grassOptions.color.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>     
                            </div>
                          </>
                        );
                      }
                      else if(currentCatalogName==='景观构筑'){            
                        // 根据选中的类别获取对应的name选项
                        const getTypeOptions = () => {
                          if (!selectedBuildingType) {
                            return [{ label: '请选择类型', value: '' }];
                          }
                          
                          const selectedType = buildingOptions.type.find(type => type.value === selectedBuildingType);
                          return selectedType ? selectedType.name : [{ label: '无可用类型', value: '' }];
                        };
                        return (
                          <>
                            <div className="catalog-filter-item">
                              <label>类别：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedBuildingType}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  setSelectedBuildingType(e.target.value);
                                  console.log('选择高度:', e.target.value);
                                  filterModelsByConditions({buildingType: e.target.value});
                                }}
                              >
                                <option value="">请选择类别</option>
                                {
                                  buildingOptions.type.map((option, index) => {
                                    // 跳过'所有类型'选项，因为它已经在上面单独添加了
                                    if (option.value === '') return null;
                                    return (
                                      <option key={index} value={option.value}>{option.label}</option>
                                    );
                                  })
                                }
                              </select>     
                            </div>

                            <div className="catalog-filter-item">
                              <label>类型：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedBuildingShape}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedBuildingShape(e.target.value);
                                  filterModelsByConditions({buildingShape: e.target.value});
                                }}
                              >
                                <option value="">所有类型</option>
                                {getTypeOptions().map((option, index) => (
                                  <option key={index} value={option.value}>{option.label}</option>
                                ))}
                              </select>     
                            </div>
                          </>
                        );
                      }
                      else if(currentCatalogName==='景观家具'){
                        const getTypeOptions=()=>{
                          if (!selectedFurnitureType) {
                            return [{ label: '请选择类型', value: '' }];
                          }
                          
                          const selectedType = furnitureOptions.type.find(type => type.value === selectedFurnitureType);
                          return selectedType ? selectedType.name : [{ label: '无可用类型', value: '' }];
                        }

                        return (
                          <>
                            <div className="catalog-filter-item">
                              <label>类别：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedFurnitureType}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedFurnitureType(e.target.value);
                                  filterModelsByConditions({furnitureType: e.target.value});
                                }}
                              >
                                <option value="">请选择家具类别</option>
                                {
                                  furnitureOptions.type.map((option, index) => {
                                    // 跳过'所有类型'选项，因为它已经在上面单独添加了
                                    if (option.value === '') return null;
                                    return (
                                      <option key={index} value={option.value}>{option.label}</option>
                                    );
                                  })
                                }
                              </select>     
                            </div>

                            <div className="catalog-filter-item">
                              <label>类型：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedFurnitureShape}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedFurnitureShape(e.target.value);
                                  filterModelsByConditions({furnitureShape: e.target.value});
                                }}
                              >
                                <option value="">请选择家具类型</option>
                                {getTypeOptions().map((option, index) => (
                                  <option key={index} value={option.value}>{option.label}</option>
                                ))}
                              </select>     
                            </div>
                          </>
                        );
                      }
                      else if(currentCatalogName==='雕塑景石'){
                        return (
                          <>
                            <div className="catalog-filter-item">
                              <label>类别：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedStoneType}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedStoneType(e.target.value);
                                  filterModelsByConditions({stoneType: e.target.value});
                                }}
                              >
                                <option value="">请选择景石类别</option>
                                {
                                  stoneOptions.type.map((option, index) => {
                                    // 跳过'所有类型'选项，因为它已经在上面单独添加了
                                    if (option.value === '') return null;
                                    return (
                                      <option key={index} value={option.value}>{option.label}</option>
                                    );
                                  })
                                }
                              </select>     
                            </div>

                            <div className="catalog-filter-item">
                              <label>尺寸：</label>
                              <select 
                                className="catalog-dropdown"
                                value={selectedStoneSize}
                                onChange={(e) => {
                                  // 这里可以根据需求实现筛选功能
                                  console.log('选择高度:', e.target.value);
                                  setSelectedStoneSize(e.target.value);
                                  filterModelsByConditions({stoneSize: e.target.value});
                                }}
                              >
                                <option value="">请选择尺寸</option>
                                {
                                  stoneOptions.size.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                  ))
                                }
                              </select>     
                            </div>
                          </>
                        );
                      }
                    })()
                  
                  
                  }
              </div>
            </div>

            {/*<div className="model-info-item">*/}
            {/*  <div className="model-image"></div>*/}
            {/*  <div className="text">22</div>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>

      {/*道路*/}
      <div className={`right-main blur ${editType === 'road' ? 'flex' : 'hidden'} road`}>
        <div className="close" onClick={() => handleCloseContent()}></div>
        <div className="left-content">
          <div className="left-content-main">
            <div className="road-item">
              <div className="label">道路工具</div>
              <div className="content">
                <div className="text">道路中心线绘制</div>
              </div>
            </div>
            
            <div className="road-item">
              <div className="label">道路宽度</div>
              <div className="content">
                <div className="slider-wrapper">
                  <Slider
                    className="r-slider"
                    defaultValue={5}
                    min={1}
                    max={20}
                    step={0.5}
                    onChange={(value) => {
                      if (editor && editor.roadTool) {
                        editor.roadTool.setRoadWidth(value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            
            <div className="road-item">
              <div className="label">道路颜色</div>
              <div className="content">
                <div className="color-picker">
                  <RColorPicker
                    color="#333333"
                    able={true}
                    id="roadColor"
                    changeColor={(color) => {
                      if (editor && editor.roadTool) {
                        // 将颜色字符串转换为十六进制数值
                        const colorHex = parseInt(color.replace('#', ''), 16);
                        editor.roadTool.setRoadColor(colorHex);
                      }
                    }}
                    onOpen={() => {
                      setShowColorPickerOverlay(true);
                    }}
                    onClose={() => {
                      setShowColorPickerOverlay(false);
                    }}
                  ></RColorPicker>
                </div>
              </div>
            </div>
            
            <div className="road-item">
              <div className="label">高度偏移</div>
              <div className="content">
                <div className="slider-wrapper">
                  <Slider
                    className="r-slider"
                    defaultValue={0.05}
                    min={0.01}
                    max={0.2}
                    step={0.01}
                    onChange={(value) => {
                      if (editor && editor.roadTool) {
                        editor.roadTool.setRoadHeightOffset(value);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            
             {/* 
              <div className="road-item">
                <div className="label">性能优化</div>
                <div className="content">
                  <div className="checkbox-wrapper">
                    <Checkbox
                      defaultChecked={false}
                      onChange={(e) => {
                        if (editor && editor.roadTool) {
                          editor.roadTool.heightCache.enabled = e.target.checked;
                          editor.roadTool.heightCache.dirty = true; // 标记需要更新缓存
                          if (e.target.checked) {
                            // 如果启用缓存，立即预计算
                            editor.roadTool.precomputeTerrainHeights();
                          }
                        }
                      }}
                    >
                      启用高度缓存
                    </Checkbox>
                  </div>
                </div>
              </div>
            */}

            <div className="road-item">
              <div className="label">绘制模式</div>
              <div className="content">
                <div className="button-group">
                  <button 
                    className={`road-btn ${editor && editor.roadTool && editor.roadTool.roadType === 'line' ? 'active' : ''}`}
                    onClick={() => {
                      if (editor && editor.roadTool) {
                        editor.roadTool.setRoadType('line');
                        // 强制重新渲染按钮状态
                        setTerrainDirection(terrainDirection);
                      }
                    }}
                  >
                    直线
                  </button>
                  <button 
                    className={`road-btn ${editor && editor.roadTool && editor.roadTool.roadType === 'curve' ? 'active' : ''}`}
                    onClick={() => {
                      if (editor && editor.roadTool) {
                        editor.roadTool.setRoadType('curve');
                        // 强制重新渲染按钮状态
                        setTerrainDirection(terrainDirection);
                      }
                    }}
                  >
                    曲线
                  </button>
                </div>
              </div>
            </div>
            
            {/*
            <div className="road-item">
              <div className="label">操作</div>
              <div className="content">
                <div className="button-group">
                  <button 
                    className="road-btn"
                    onClick={() => {
                      if (editor && editor.roadTool) {
                        editor.roadTool.finishRoad();
                        messageApi.open({type: "success", content: "道路已确认"});
                      }
                    }}
                  >
                    确认道路
                  </button>
                  <button 
                    className="road-btn"
                    onClick={() => {
                      if (editor && editor.roadTool) {
                        editor.roadTool.isDrawing = false;
                        editor.roadTool.roadPoints = [];
                        editor.roadTool.previewPoints = [];
                        editor.roadTool.clearPreview();
                        messageApi.open({type: "info", content: "已取消当前道路"});
                      }
                    }}
                  >
                    取消道路
                  </button>
                </div>
              </div>
            </div>
            */}

          </div>
        </div>
        <div className="right-content">
          <div className="road-info">
            <div className="info-text">
              <p>使用说明：</p>
              <p>1. 调整道路宽度、道路颜色以及绘制模式等参数</p>
              <p>2. 点击地形设置道路点，形成道路中心线</p>
              <p>3. 完成后双击鼠标左键生成道路模型，道路会自动贴合地形起伏</p>
              <p>4. 点击鼠标右键可以取消当前道路创建</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomMenu;
